<template>
    <div class="page-header">

        <b-breadcrumb v-if="crumbs" :items="crumbs"></b-breadcrumb>

        <h1 class="page-title">{{ text }}</h1>
        <p class="page-description">{{ description }}</p>

    </div>
</template>

<script>
export default {
  name: 'Pageheader',
  props: {
    text: String,
    description: String,
    crumbs: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-header {
    margin-bottom: 3rem;
}
.page-title {
    text-align: left;
}
.page-description {
    opacity: 0.5;
    text-align: left;
}


@media only screen and (max-width: 576px) {
    .page-title {
        font-size: 1.5em;
    }
}

@media only screen and (min-width: 576px) {
    .page-title {
        font-size: 2em;
    }
}


</style>
